import React, { useRef } from "react";
import { Row, Col, Card, Spinner } from "reactstrap";
import { useForm, Controller } from "react-hook-form";

import bgImage from "../../assets/images/bgImage1.jpg";
import useMfaVerification from "./useMfaVerification";
import { useQueryClient } from "@tanstack/react-query";
import useResendCode from "./useResendCode";
import toast from "react-hot-toast";

const MFAPage = () => {
  const queryClient = useQueryClient();

  const inputRefs = useRef([]);

  //   custom hook
  const {isPending,verify} = useMfaVerification();
  const mfaData = queryClient.getQueryData(["mfa-session"])
  const{isResending,resendOTP} = useResendCode();

  // const handleResendOTP=()=>{
  //   toast.loading("Regenerating OTP...Please wait...",{id:'resend-otp'})
  //   const session_token = mfaData.session_token
  //   const loginData = localStorage.getItem('loginData')
  //   const session_token_local = loginData.session_token

  //   const both_token = session_token ?? session_token_local

  //   resendOTP({"session_token":both_token})
  // }

  const handleResendOTP=()=>{
    toast.loading("Regenerating OTP...Please wait...",{id:'resend-otp'})

    let session_token_local;

    try{
      const loginData = JSON.parse(localStorage.getItem('loginData') || '{}')
      session_token_local = loginData?.session_token
    }catch{
      session_token_local = undefined
    }

    const both_token = mfaData?.session_token ?? session_token_local

    if (!both_token){
      toast.error("Session expired. Please log in again.", { id: 'resend-otp' })
      return;
    }

    resendOTP({"session_token":both_token})
  }

  const {control,handleSubmit,formState: { errors },setValue} = useForm({
    defaultValues: {
      otp: ["", "", "", "", "", ""], 
    },
    mode: "onChange",
  });

  const onSubmit = (data) => {
    const otp = data.otp.join("");
    
    console.log(mfaData)
    console.log(mfaData.session_token)
    console.log("OTP:", otp);

    // API Call
    // verifyMFA({ otp })
    verify({otp,session_token:mfaData.session_token})
  };

  return (
    <div className="account-pages">
      <div
        className="accountbg"
        style={{
          background: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card
          style={{
            width: "420px",
            padding: "25px",
            borderRadius: "15px",
            border: "1.5px solid white",
            backgroundColor: "white",
            boxShadow: "0 0 15px rgba(0,0,0,.2)",
          }}
        >
          <Row>
            <Col
              className="text-center"
              style={{ marginBottom: "25px" }}
            >
              <h2 style={{ color: "#00ADF0" }}>
                Multi-Factor Authentication
              </h2>

              <h6 style={{ fontSize: "13px" }}>
                Enter the 6-digit verification code sent to your email.
              </h6>
            </Col>
          </Row>

          <form onSubmit={handleSubmit(onSubmit)}>
            <label className="form-label">Verification Code</label>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {Array.from({ length: 6 }).map((_, index) => (
                <Controller
                  key={index}
                  name={`otp.${index}`}
                  control={control}
                  rules={{
                    required: true,
                    pattern: /^[0-9]$/,
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      ref={(el) => {
                        field.ref(el);
                        inputRefs.current[index] = el;
                      }}
                      type="text"
                      maxLength={1}
                      className="form-control text-center"
                      style={{
                        width: "52px",
                        height: "55px",
                        fontSize: "22px",
                        fontWeight: "600",
                      }}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");

                        field.onChange(value);

                        if (
                          value &&
                          index < 5
                        ) {
                          inputRefs.current[index + 1]?.focus();
                        }
                      }}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" &&
                          !field.value &&
                          index > 0
                        ) {
                          inputRefs.current[index - 1]?.focus();
                        }
                      }}
                      onPaste={(e) => {
                          e.preventDefault();

                          const pasted = e.clipboardData
                            .getData("text")
                            .replace(/\D/g, "")
                            .slice(0, 6);

                          pasted.split("").forEach((digit, i) => {
                            setValue(`otp.${i}`, digit, {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          });

                          inputRefs.current[Math.min(pasted.length, 6) - 1]?.focus();
                        }}
                    />
                  )}
                />
              ))}
            </div>

            {errors.otp && (
              <div className="text-danger mb-2">
                Please enter all 6 digits.
              </div>
            )}

            <button
              type="submit"
              className="btn w-100 mt-3"
              style={{
                backgroundColor: "#00ADF0",
                color: "#fff",
              }}
              disabled={isPending}
            >
              {isPending ? <Spinner size='sm' /> : 'Verify'}
            </button>

            <div className="text-center mt-4">
              Didn't receive the code?
              <button
                type="button"
                className="btn btn-link p-0 ms-1"
                onClick={()=> handleResendOTP()}
                disabled={isResending}
              >
                Resend
              </button>
            </div>

            <div className="text-center mt-3">
              © {new Date().getFullYear()} TrueFocus Automation. All rights
              reserved.
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default MFAPage;